/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
   var timeRemaining = 5 * 60;
   // Start the timer
   var timerInterval = setInterval(function () {
         if(document.getElementById("time-minutes")){
            // console.log("rama time running");
            var minutes = Math.floor(timeRemaining / 60);
            var seconds = timeRemaining % 60;   
            
            // Pad the minutes and seconds with leading zeros if necessary
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
        
            // Update the timer display
            document.getElementById("time-minutes").textContent = minutes;
            document.getElementById("time-seconds").textContent = seconds;
        
            // Decrease the time remaining by 1 second
            if (timeRemaining <= 0) 
            {
              timeRemaining = 5 * 60;
            } 
            else 
            {
              timeRemaining--;
            }
         }//if closed
      }, 1000);
});

document.addEventListener("DOMContentLoaded", function() {
 document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('Cart__Checkout') || el.closest('.Cart__Checkout')) {
      if(!el.classList.contains('Cart__Checkout')) {
      	el = el.closest('.Cart__Checkout');
      }
     el.classList.add('is_loader_button');
    }
  });
});

window.addEventListener("load", (event) => {
  
  let custom_sticky_product_form = document.querySelector('.custom_sticky_product_form');
  if(custom_sticky_product_form) {
    window.scrollTo(0, 0);


    var Product__Wrapper = document.querySelector('.Product__Wrapper');
    if(window.innerWidth > 1008) {
      var Product__Wrapper_bottomOffset  = Product__Wrapper.getBoundingClientRect().top  + Product__Wrapper.offsetHeight ;
    }
    else {
      var Product__Wrapper_bottomOffset = document.querySelector("#main").getBoundingClientRect().top  + document.querySelector("#main").offsetHeight;
    }
  
    
    var static_ProductForm__AddToCart = document.querySelector('.Product__InfoWrapper .ProductForm__BuyButtons');
    var bottomOffsetButton  = static_ProductForm__AddToCart.getBoundingClientRect().top;
      bottomOffsetButton = bottomOffsetButton + static_ProductForm__AddToCart.offsetHeight;
    
    document.addEventListener('scroll', function(e) {
      var window_scrollY = window.scrollY;
      var header = document.querySelector('.shopify-section--header');
      var scrollY = header.offsetHeight + window_scrollY;

      var lastStickyPosition = Product__Wrapper_bottomOffset - header.offsetHeight + 20;


      if(window.innerWidth > 1007) {
      if(scrollY > bottomOffsetButton && scrollY < lastStickyPosition) {
        custom_sticky_product_form.classList.add('is_visible');
      } else {
        custom_sticky_product_form.classList.remove('is_visible');
      }
      } else {

        const section = document.querySelector('.ProductForm__BuyButtons');
        const sectionPosition = section.offsetTop + 1000;
        if (window_scrollY >= sectionPosition) {
          custom_sticky_product_form.classList.add('sticky');
        }else{
           custom_sticky_product_form.classList.remove('sticky');
        }
        
       scrollY =  window.scrollY + window.innerHeight;
        // console.log(scrollY + "" + Product__Wrapper_bottomOffset);
         if(scrollY < Product__Wrapper_bottomOffset) {
        custom_sticky_product_form.classList.remove('mobile_hide');
           
      } else {
        custom_sticky_product_form.classList.add('mobile_hide');
        
           
      }
      }
    });
    custom_sticky_product_form.querySelector('.ProductForm__StickyAddToCart').addEventListener('click', function(e) {
    e.preventDefault();

      let productForm = this.closest('.ProductForm');
      let isTriggerSubmitButton = this.classList.contains('isTriggerSubmitButton');
      if(productForm) {
        if(isTriggerSubmitButton) {
          productForm.querySelector('[type="submit"]').dispatchEvent(new CustomEvent('click', {cancelable: true, bubbles: true,  detail: { manualTrigger: true} }));        
        } else {
          let ProductForm__Variants = productForm.querySelector('.ProductForm__Variants');
          if(ProductForm__Variants) {

            let y = ProductForm__Variants.getBoundingClientRect().top + window.scrollY  - document.querySelector('.shopify-section--header').offsetHeight;

          
          if(window.innerWidth < 1008) {
            y = y - window.innerHeight + custom_sticky_product_form.offsetHeight + ProductForm__Variants.offsetHeight + document.querySelector('.shopify-section--header').offsetHeight;
          } 
      
            
            window.scroll({
            top: y,
            behavior: 'smooth'
            });

            

          }
        }
      }
  });
    
  //   custom_sticky_product_form.querySelector('.ProductForm__OptionDropdown').addEventListener('change', function(e) {
  //     e.preventDefault();

  //     let sectionWrapper = this.closest('.Product');
  //       let productForm = sectionWrapper.closest('.Product__Info  .ProductForm');
  //       let value = this.value;
  //       let optionName = this.getAttribute('data-option-name');
  //     console.log(optionName);
      
  //     let Popover__ValueListEl = sectionWrapper.querySelector('.Popover__ValueList[data-option-name="'+optionName+'"]');
  //     console.log(Popover__ValueListEl);
  //     if(Popover__ValueListEl) {
  //       let Popover__ValueEl = Popover__ValueListEl.querySelector('.Popover__Value[data-value="' + value + '"]');
  //       console.log(Popover__ValueEl);
  //       if(Popover__ValueEl) {
  //         Popover__ValueEl.dispatchEvent(new CustomEvent('click', { bubbles: true}));      
  //       }
  //     }
    
  // });

    
    
  }
});

(function () {
  if (window.__tonaKlaviyoFormDedupeInitialized) return;
  window.__tonaKlaviyoFormDedupeInitialized = true;

  let dedupeTimer;

  const THEME_SELECTOR =
    '#footer_klavio, .Footer, #main, main, .shopify-section';

  function isKlaviyoContainer(el) {
    return (
      el.nodeType === 1 &&
      [...el.classList].some((cls) => cls.startsWith('klaviyo-form-'))
    );
  }

  function markEmbedContainer(root = document) {
    root.querySelectorAll('[class*="klaviyo-form-"]').forEach((el) => {
      if (el.dataset.tonaKlaviyoEmbed === 'true') return;
      if (!isKlaviyoContainer(el)) return;
      if (!el.closest(THEME_SELECTOR)) return;

      el.dataset.tonaKlaviyoEmbed = 'true';
    });
  }

  function dedupeEmbeds() {
    document
      .querySelectorAll('[data-tona-klaviyo-embed="true"]')
      .forEach((container) => {
        while (container.children.length > 1) {
          container.lastElementChild.remove();
        }
      });
  }

  function runDedupe() {
    markEmbedContainer();
    dedupeEmbeds();
  }

  function scheduleDedupe() {
    clearTimeout(dedupeTimer);
    dedupeTimer = setTimeout(runDedupe, 300);
  }

  function init() {
    runDedupe();

    window.addEventListener('popstate', scheduleDedupe);

    ['pushState', 'replaceState'].forEach((method) => {
      const original = history[method];
      history[method] = function () {
        const result = original.apply(this, arguments);
        scheduleDedupe();
        return result;
      };
    });

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.addedNodes.length)) {
        scheduleDedupe();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  if (window.__tonaColorFilteredGalleryInitialized) return;
  window.__tonaColorFilteredGalleryInitialized = true;

  var stateBySlideshow = new WeakMap();

  function handleize(value) {
    if (!value) return '';
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getAltKey(value) {
    if (!value) return '';
    return String(value).trim().split('_')[0] || '';
  }

  function getFlickity(slideshow) {
    if (typeof Flickity !== 'undefined' && Flickity && typeof Flickity.data === 'function') {
      return Flickity.data(slideshow);
    }
    return null;
  }

  function getColorOptionPosition(section) {
    var colorRadio = section.querySelector('.ColorSwatch__Radio[data-option-position]');
    if (colorRadio) return parseInt(colorRadio.getAttribute('data-option-position'), 10) || null;

    var lists = section.querySelectorAll('.Popover__ValueList[data-option-name]');
    for (var i = 0; i < lists.length; i++) {
      var optionName = (lists[i].getAttribute('data-option-name') || '').toLowerCase();
      if (optionName.indexOf('color') === -1 && optionName.indexOf('colour') === -1) continue;
      var anyValue = lists[i].querySelector('.Popover__Value[data-option-position]');
      if (anyValue) return parseInt(anyValue.getAttribute('data-option-position'), 10) || null;
    }

    return null;
  }

  function getAllColorHandles(section, colorPosition) {
    var handles = new Set();
    if (!colorPosition) return handles;

    var radios = section.querySelectorAll('.ColorSwatch__Radio[data-option-position="' + String(colorPosition) + '"]');
    for (var i = 0; i < radios.length; i++) {
      var variantAlt = radios[i].getAttribute('data-variant-alt');
      var key = variantAlt ? getAltKey(variantAlt) : radios[i].value;
      handles.add(handleize(key));
    }

    var popoverValues = section.querySelectorAll('.Popover__Value[data-option-position="' + String(colorPosition) + '"]');
    for (var j = 0; j < popoverValues.length; j++) {
      var v = popoverValues[j].getAttribute('data-value');
      if (v) handles.add(handleize(v));
    }

    return handles;
  }

  function getSelectedColorValue(section, colorPosition, variant) {
    if (colorPosition) {
      var checked = section.querySelector('.ColorSwatch__Radio[data-option-position="' + String(colorPosition) + '"]:checked');
      if (checked) return checked.getAttribute('data-variant-alt') || checked.value;

      var pop = section.querySelector('.Popover__Value.is-selected[data-option-position="' + String(colorPosition) + '"]');
      if (pop) return pop.getAttribute('data-value');
    }

    if (variant && colorPosition) {
      var key = 'option' + String(colorPosition);
      if (variant[key]) return variant[key];
    }

    return null;
  }

  function buildState(section, slideshow) {
    var cells = Array.prototype.slice.call(slideshow.querySelectorAll('.Carousel__Cell'));
    var hasAnyTagged = false;
    var colorPos = getColorOptionPosition(section);
    var colorHandles = getAllColorHandles(section, colorPos);

    var cellMeta = cells.map(function (el) {
      var color = el.getAttribute('data-media-color-handle') || '';
      if (color) hasAnyTagged = true;

      if (!el.getAttribute('data-original-media-position')) {
        var originalPos = el.getAttribute('data-media-position') || '';
        if (originalPos) el.setAttribute('data-original-media-position', originalPos);
      }

      if (!el.getAttribute('data-original-image-media-position')) {
        var originalImagePos = el.getAttribute('data-image-media-position');
        if (originalImagePos !== null && originalImagePos !== '') {
          el.setAttribute('data-original-image-media-position', originalImagePos);
        }
      }

      return {
        el: el,
        mediaId: el.getAttribute('data-media-id') || '',
        position: parseInt(el.getAttribute('data-media-position'), 10) || 0,
        color: color,
        type: el.getAttribute('data-media-type') || ''
      };
    });

    cellMeta.sort(function (a, b) { return a.position - b.position; });

    var byColor = {};
    var shared = [];
    var unassigned = [];
    var hasAnyValidTag = false;
    cellMeta.forEach(function (m) {
      if (m.color === 'all') {
        shared.push(m);
        hasAnyValidTag = true;
        return;
      }

      if (!m.color) {
        unassigned.push(m);
        return;
      }

      if (colorHandles.size && colorHandles.has(m.color)) {
        hasAnyValidTag = true;
        if (!byColor[m.color]) byColor[m.color] = [];
        byColor[m.color].push(m);
        return;
      }

      unassigned.push(m);
    });

    var state = {
      section: section,
      slideshow: slideshow,
      cellMeta: cellMeta,
      byColor: byColor,
      shared: shared,
      unassigned: unassigned,
      colorHandles: colorHandles,
      hasAnyTagged: hasAnyTagged,
      hasAnyValidTag: hasAnyValidTag,
      currentColor: null,
      selectListenerBound: false
    };

    stateBySlideshow.set(slideshow, state);
    return state;
  }

  function updateThumbVisibility(section, visibleMediaIds) {
    var thumbs = section.querySelectorAll('.Product__SlideshowNavImage[data-media-id]');
    for (var i = 0; i < thumbs.length; i++) {
      var id = thumbs[i].getAttribute('data-media-id');
      thumbs[i].style.display = visibleMediaIds.has(id) ? '' : 'none';
    }

    var dots = section.querySelectorAll('.Product__SlideshowNavDot');
    for (var j = 0; j < dots.length; j++) {
      var href = dots[j].getAttribute('href') || '';
      var match = href.match(/#Media(\d+)/);
      if (match && match[1]) {
        dots[j].style.display = visibleMediaIds.has(match[1]) ? '' : 'none';
      } else {
        dots[j].style.display = '';
      }
    }
  }

  function rebuildMobileDots(section, count) {
    var nav = section.querySelector('.Product__SlideshowMobileNav .flickity-page-dots');
    if (!nav) return;

    var html = '';
    for (var i = 0; i < count; i++) {
      html += '<button type="button" class="dot' + (i === 0 ? ' is-selected' : '') + '" data-index="' + i + '"></button>';
    }
    nav.innerHTML = html;
  }

  function restoreOriginalPositions(state) {
    state.cellMeta.forEach(function (m) {
      var original = m.el.getAttribute('data-original-media-position');
      if (original) m.el.setAttribute('data-media-position', original);

      var originalImagePos = m.el.getAttribute('data-original-image-media-position');
      if (originalImagePos !== null && originalImagePos !== '') {
        m.el.setAttribute('data-image-media-position', originalImagePos);
      }

      m.el.classList.remove('Product__SlideItem--hidden');
    });
  }

  function renumberVisiblePositions(desired) {
    var imageIndex = 0;
    for (var i = 0; i < desired.length; i++) {
      desired[i].el.setAttribute('data-media-position', String(i + 1));
      desired[i].el.classList.remove('Product__SlideItem--hidden');

      if (desired[i].el.classList && desired[i].el.classList.contains('Product__SlideItem--image')) {
        desired[i].el.setAttribute('data-image-media-position', String(imageIndex));
        imageIndex += 1;
      }
    }
  }

  function syncActionList(section, flkty) {
    var actionList = section.querySelector('.Product__Gallery .Product__ActionList');
    if (!actionList) return;

    var selected = null;
    if (flkty && flkty.selectedElement) {
      selected = flkty.selectedElement;
    } else {
      var selectedEl = section.querySelector('.Product__SlideItem.is-selected');
      if (selectedEl) selected = selectedEl;
    }

    var isImage = selected && selected.classList && selected.classList.contains('Product__SlideItem--image');
    if (isImage) {
      actionList.classList.remove('is-hidden');
    } else {
      actionList.classList.add('is-hidden');
    }
  }

  function selectFirstImageCell(flkty) {
    if (!flkty || !flkty.cells || !flkty.cells.length) return;
    for (var i = 0; i < flkty.cells.length; i++) {
      var el = flkty.cells[i] && flkty.cells[i].element;
      if (el && el.classList && el.classList.contains('Product__SlideItem--image')) {
        flkty.select(i, false, true);
        return;
      }
    }
    flkty.select(0, false, true);
  }

  function syncImagePositionsFromFlickity(flkty) {
    if (!flkty || !flkty.cells || !flkty.cells.length) return;
    var imageIndex = 0;
    for (var i = 0; i < flkty.cells.length; i++) {
      var el = flkty.cells[i] && flkty.cells[i].element;
      if (!el || !el.classList) continue;
      if (el.classList.contains('Product__SlideItem--image')) {
        el.setAttribute('data-image-media-position', String(imageIndex));
        imageIndex += 1;
      }
    }
  }

  function bindMobileDotSync(section, slideshow, flkty, state) {
    if (!flkty || state.selectListenerBound) return;
    state.selectListenerBound = true;

    flkty.on('select', function () {
      syncActionList(section, flkty);
      var nav = section.querySelector('.Product__SlideshowMobileNav .flickity-page-dots');
      if (!nav) return;
      var dots = nav.querySelectorAll('.dot');
      for (var i = 0; i < dots.length; i++) {
        if (i === flkty.selectedIndex) {
          dots[i].classList.add('is-selected');
        } else {
          dots[i].classList.remove('is-selected');
        }
      }
    });
  }

  function applyFilter(section, variant, force) {
    var slideshow = section.querySelector('.Product__Slideshow');
    if (!slideshow) return;

    var state = stateBySlideshow.get(slideshow) || buildState(section, slideshow);
    if (!state.hasAnyTagged || !state.hasAnyValidTag) return;

    var colorPos = getColorOptionPosition(section);
    var colorValue = getSelectedColorValue(section, colorPos, null);
    var colorHandle = handleize(getAltKey(colorValue || ''));

    if (!colorHandle && !force) return;

    restoreOriginalPositions(state);

    var flkty = getFlickity(slideshow);

    for (var k = 0; k < state.cellMeta.length; k++) {
      state.cellMeta[k].el.style.display = '';
      state.cellMeta[k].el.classList.remove('Product__SlideItem--hidden');
    }

    var desired = [];
    var hasColorSpecific = !!(colorHandle && state.byColor[colorHandle] && state.byColor[colorHandle].length);

    if (!colorHandle) {
      desired = state.cellMeta.slice();
    } else if (hasColorSpecific) {
      Array.prototype.push.apply(desired, state.shared);
      Array.prototype.push.apply(desired, state.byColor[colorHandle]);
    } else {
      desired = state.cellMeta.slice();
    }

    desired.sort(function (a, b) { return a.position - b.position; });

    var isShowingAll = desired.length === state.cellMeta.length;

    if (flkty && flkty.isActive) {
      var currentElements = flkty.cells.map(function (c) { return c.element; });
      flkty.remove(currentElements);
      flkty.append(desired.map(function (m) { return m.el; }));
      if (isShowingAll) {
        restoreOriginalPositions(state);
      } else {
        renumberVisiblePositions(desired);
      }
      flkty.reloadCells();
      flkty.resize();
      selectFirstImageCell(flkty);
      bindMobileDotSync(section, slideshow, flkty, state);
      syncActionList(section, flkty);
      rebuildMobileDots(section, desired.length);
    } else {
      var desiredSet = new Set(desired.map(function (m) { return m.el; }));
      state.cellMeta.forEach(function (m) {
        m.el.style.display = desiredSet.has(m.el) ? '' : 'none';
        if (desiredSet.has(m.el)) {
          m.el.classList.remove('Product__SlideItem--hidden');
        }
      });
      if (isShowingAll) {
        restoreOriginalPositions(state);
      } else {
        renumberVisiblePositions(desired);
      }
      syncActionList(section, null);
      rebuildMobileDots(section, desired.length);
    }

    var visibleIds = new Set(desired.map(function (m) { return m.mediaId; }));
    updateThumbVisibility(section, visibleIds);
  }

  function scheduleFilter(section, variant, force) {
    var slideshow = section.querySelector('.Product__Slideshow');
    if (!slideshow) return;

    var state = stateBySlideshow.get(slideshow) || buildState(section, slideshow);
    if (!state) return;

    state.pendingVariant = variant || null;
    state.pendingForce = !!force;

    if (!state.applyToken) state.applyToken = 0;
    state.applyToken += 1;
    var token = state.applyToken;

    if (state.pendingTimer) {
      clearTimeout(state.pendingTimer);
      state.pendingTimer = null;
    }

    if (state.isApplying) return;

    state.pendingTimer = setTimeout(function () {
      state.pendingTimer = null;
      if (state.applyToken !== token) return;

      state.isApplying = true;
      try {
        applyFilter(section, state.pendingVariant, state.pendingForce);
      } finally {
        state.isApplying = false;
        if (state.pendingTimer) return;
        if (state.applyToken !== token) {
          scheduleFilter(section, state.pendingVariant, true);
        }
      }
    }, 60);
  }

  function initSection(section) {
    if (!section.classList || !section.classList.contains('liftfit-product')) return;
    var slideshow = section.querySelector('.Product__Slideshow');
    if (!slideshow) return;
    if (slideshow.dataset.tonaColorFilterInit === 'true') return;
    slideshow.dataset.tonaColorFilterInit = 'true';
    var state = buildState(section, slideshow);
    if (state && !state.optionListenerBound) {
      state.optionListenerBound = true;
      section.addEventListener('change', function (e) {
        var radio = e.target;
        if (!radio || !radio.classList) return;
        if (!(radio.classList.contains('ColorSwatch__Radio') || radio.classList.contains('SizeSwatch__Radio'))) return;
        if (!radio.getAttribute || !radio.getAttribute('data-option-position')) return;
        scheduleFilter(section, null, true);
      });
    }
    scheduleFilter(section, null, true);
    setTimeout(function () {
      scheduleFilter(section, null, true);
    }, 250);
  }

  function initAll() {
    var sections = document.querySelectorAll('.Product.liftfit-product[data-section-type="product"]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('theme:loading:end', initAll);

  document.addEventListener('variant:changed', function (event) {
    if (!event || !event.target) return;
    var section = event.target.closest && event.target.closest('.Product.liftfit-product[data-section-type="product"]');
    if (!section) return;
    initSection(section);
    scheduleFilter(section, event.detail && event.detail.variant, false);
  });

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest && event.target.closest('.Product.liftfit-product [data-action="open-product-zoom"]');
      if (!btn) return;
      var section = btn.closest('.Product.liftfit-product[data-section-type="product"]');
      if (!section) return;
      var slideshow = section.querySelector('.Product__Slideshow');
      if (!slideshow) return;
      var flkty = getFlickity(slideshow);
      if (flkty && flkty.isActive) {
        syncImagePositionsFromFlickity(flkty);
      }

      var selectedEl = (flkty && flkty.selectedElement) || section.querySelector('.Product__SlideItem.is-selected');
      if (!selectedEl || !selectedEl.classList || !selectedEl.classList.contains('Product__SlideItem--image')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var idx = parseInt(selectedEl.getAttribute('data-image-media-position'), 10);
      if (isNaN(idx)) {
        if (flkty && flkty.isActive) {
          syncImagePositionsFromFlickity(flkty);
          selectedEl = flkty.selectedElement || selectedEl;
          idx = parseInt(selectedEl.getAttribute('data-image-media-position'), 10);
        }
      }

      var thumb = null;
      if (!isNaN(idx)) {
        thumb = section.querySelector('.Product__Slideshow .Carousel__Cell[data-image-media-position="' + String(idx) + '"] img');
      }

      if (!thumb && flkty && flkty.isActive) {
        selectFirstImageCell(flkty);
        syncImagePositionsFromFlickity(flkty);
        selectedEl = flkty.selectedElement || selectedEl;
        idx = parseInt(selectedEl.getAttribute('data-image-media-position'), 10);
        if (!isNaN(idx)) {
          thumb = section.querySelector('.Product__Slideshow .Carousel__Cell[data-image-media-position="' + String(idx) + '"] img');
        }
      }

      if (!thumb) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
